export const AVAILABLE_STATES = [
    // 'usa-california',
    // 'usa-florida',
    // 'usa-georgia',
    // 'usa-minnesota',
    // 'usa-north-carolina',
    // 'usa-nevada',
    // 'usa-nebraska',
    // 'usa-south-carolina',
    // 'usa-texas',
    // 'usa-illinois',
    // 'usa-indiana',
    'usa_iowa',
    // 'usa-utah',
] as const;

// Add more course-related configuration here as needed
export const COURSE_SEARCH_DEFAULTS = {
    initialRadius: 20,
    maxRadius: 100,
    radiusOptions: [1, 5, 10, 20, 50, 100] as const
}; 